<template>
  <div class="cell-main-row">
    <slot name="column">
      <div class="cell-main-row-left van-ellipsis">{{label}}</div>
      <div class="cell-main-row-right" :class="textClass">{{text}}</div>
    </slot>
  </div>
</template>

<script>
  export default {
    //列表页过滤下拉
    name: 'BaseColumn',
    data() {
      return {
      }
    },
    props: {
      label: {
        type: String,
        default: ""
      },
      text: {

      },
      textClass:{
        type: String,
        default: ""
      }
    },
    watch: {

    },
    methods: {

    },
    mounted: function() {

    }
  }
</script>

<style scoped="scoped">
  .column-tag {
    margin-left: 10px;
  }
</style>
